import React, { Component, PropTypes } from 'react';
import moment from 'moment';
import truncate from 'lodash/truncate';
import { v4 } from 'node-uuid';
import { Link } from 'react-router';
import { ADMIN_ROOT } from 'common/variables';
import Avatar from 'common/components/avatar';

const EliteWindowClosedNotice = () => (
  <div className="empty-state-content">
    <p>
      The reservation window for this Elite project has closed, so it&apos;s not possible to
      invite anyone else.
    </p>
  </div>
);

const EmptyResults = ({ isEliteWindowClosed, customEmptyLabel, canInvite }) => (
  <div className="small-16 column">
    <div className="empty-state no-results">
      <div className="empty-state-content">
        <h3>{ customEmptyLabel || "You haven't invited any creatives" }</h3>

        { isEliteWindowClosed && <EliteWindowClosedNotice /> }

        { !isEliteWindowClosed && canInvite &&
        <div className="empty-state-cta">
          <Link className="btn btn-primary" to="/explore/creatives/">Invite</Link>
        </div> }
      </div>
    </div>
  </div>
);

EmptyResults.propTypes = {
  isEliteWindowClosed: PropTypes.bool,
  canInvite: PropTypes.bool,
  customEmptyLabel: PropTypes.string,
};

class InviteTableRow extends Component {
  constructor(props) {
    super(props);

    this.state = { resent: false };
    this.resend = this.resend.bind(this);
  }

  resend() {
    const { user, projectId, resendInvite, fetch } = this.props;
    resendInvite(user.id, { project: projectId }).then(fetch);
    this.setState({ resent: true });
  }

  render() {
    const { user, last_sent_at, canInvite, isAdmin } = this.props;
    const creativeUrl = isAdmin? `${ADMIN_ROOT}/creative/${user.id}/` : `/users/${user.username}/`;

    return (<tr>
      <td>
        <Link to={creativeUrl} target="_blank">
          <Avatar user={user} extraClasses="avatar-sm show-for-medium" /> {' '}
          <span className="hide-for-small-only">{user.username}</span>
          <span className="show-for-small-only">{truncate(user.username, { length: 15 })}</span>
        </Link>
      </td>
      <td>{moment(last_sent_at).fromNow()}</td>
      { canInvite?
      <td className="action">
        {this.state.resent
          ? <span>Invitation Resent</span>
          : <button className="btn btn-text btn-md" onClick={this.resend}>Resend Invite</button>
        }
      </td> : <td /> }
    </tr>);
  }
}

const InviteTable = ({
  invites, resendInvite, projectId, isEliteWindowClosed, customEmptyLabel, canInvite, fetch,
  isAdmin
}) => {
  if (!invites.length) {
    return (
      <EmptyResults isEliteWindowClosed={isEliteWindowClosed} customEmptyLabel={customEmptyLabel}
        canInvite={canInvite} />
    );
  }

  return (<div className="small-16 column">
    <table className="table table-default access invite">
      <thead>
        <tr>
          <td>user</td>
          <td>invited</td>
          <td />
        </tr>
      </thead>
      <tbody>
        { invites.map(invite => (
          <InviteTableRow
            key={v4()}
            {...invite}
            canInvite={canInvite}
            resendInvite={resendInvite}
            fetch={fetch}
            projectId={projectId}
            isAdmin={isAdmin}
          />
        )) }
      </tbody>
    </table>

    { isEliteWindowClosed && <EliteWindowClosedNotice /> }

    { !isEliteWindowClosed && canInvite &&
    <Link className="btn btn-primary btn-md btn-invite-more" to="/explore/creatives/">
      Invite More
    </Link> }
  </div>);
};

const UserShape = {
  id: PropTypes.number.isRequired,
  username: PropTypes.string.isRequired,
  avatar: PropTypes.string.isRequired,
};

InviteTableRow.propTypes = {
  user: PropTypes.shape(UserShape),
  last_sent_at: PropTypes.string.isRequired,
  projectId: PropTypes.number.isRequired,
  resendInvite: PropTypes.func.isRequired,
  fetch: PropTypes.func.isRequired,
  canInvite: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool,
};

InviteTable.propTypes = {
  invites: PropTypes.arrayOf(PropTypes.shape({
    user: PropTypes.shape(UserShape),
    last_sent_at: PropTypes.string.isRequired,
  })).isRequired,
  projectId: PropTypes.number.isRequired,
  resendInvite: PropTypes.func.isRequired,
  fetch: PropTypes.func.isRequired,
  isEliteWindowClosed: PropTypes.bool,
  customEmptyLabel: PropTypes.string,
  canInvite: PropTypes.bool,
  isAdmin: PropTypes.bool,
};

export { InviteTableRow, EmptyResults };
export default InviteTable;



// WEBPACK FOOTER //
// ./project/components/invited.jsx